import React from 'react';
import useAuthUser from './useAuthUser';

const authComponentSwitch = (AnonymousComponent, AuthenticatedComponent) => {
  return () => {
    const authUser = useAuthUser();
    return (
      <>
        {!!authUser && <AuthenticatedComponent />}
        {authUser === null && <AnonymousComponent />}
        {authUser === undefined && <></>}
      </>
    );
  };
};

export default authComponentSwitch;
